import React from 'react';
import SpatialGridComponent from '../spatial/spatial-grid-component';
import TabPanelComponent, { Tab } from '../../shared/components/tab-panel/tab-panel-component';

import './spatial-import-results.scss';

const SpatialImportResults = (props) => {
  const { messageBoxGlobal, data } = props;

  let hasData = data !== null;
  let tabs = null;

  if (hasData) {

    let hasBlocks = data.blocks !== null && data.blocks !== undefined;
    let blocksCount = hasBlocks ? data.blocks.length : 0;

    let hasImportedFields = data.importedFields !== null && data.importedFields !== undefined;
    let importedFieldsCount = hasImportedFields ? data.importedFields.length : 0;

    let hasNotImportedFields = data.notImportedFields !== null && data.notImportedFields !== undefined;
    let notImportedFieldsCount = hasNotImportedFields ? data.notImportedFields.length : 0;

    let hasImportedDiscoveries = data.importedDiscoveries !== null && data.importedDiscoveries !== undefined;
    let importedDiscoveriesCount = hasImportedDiscoveries ? data.importedDiscoveries.length : 0;

    let hasNotImportedDiscoveries = data.notImportedDiscoveries !== null && data.notImportedDiscoveries !== undefined;
    let notImportedDiscoveriesCount = hasNotImportedDiscoveries ? data.notImportedDiscoveries.length : 0;

    let hasImportedProspects = data.importedProspects !== null && data.importedProspects !== undefined;
    let importedProspectsCount = hasImportedProspects ? data.importedProspects.length : 0;

    let hasNotImportedProspects = data.notImportedProspects !== null && data.notImportedProspects !== undefined;
    let notImportedProspectsCount = hasNotImportedProspects ? data.notImportedProspects.length : 0;

    let hasImportedSegments = data.importedSegments !== null && data.importedSegments !== undefined;
    let importedSegmentsCount = hasImportedSegments ? data.importedSegments.length : 0;

    tabs = [
      new Tab('Imported Blocks (' + blocksCount.toString() + ')', hasBlocks ? <SpatialGridComponent messageBoxGlobal={messageBoxGlobal} data={data.blocks} type={'block_results'} /> : null),

      new Tab('Imported Fields (' + importedFieldsCount.toString() + ')', hasImportedFields ? <SpatialGridComponent messageBoxGlobal={messageBoxGlobal} data={data.importedFields} type={'field_results'} /> : null),
      new Tab('Not Imported Fields (' + notImportedFieldsCount.toString() + ')', hasNotImportedFields ? <SpatialGridComponent messageBoxGlobal={messageBoxGlobal} data={data.notImportedFields} type={'field_results'} /> : null),

      new Tab('Imported Discoveries (' + importedDiscoveriesCount.toString() + ')', hasImportedDiscoveries ? <SpatialGridComponent messageBoxGlobal={messageBoxGlobal} data={data.importedDiscoveries} type={'field_results'} /> : null),
      new Tab('Not Imported Discoveries (' + notImportedDiscoveriesCount.toString() + ')', hasNotImportedDiscoveries ? <SpatialGridComponent messageBoxGlobal={messageBoxGlobal} data={data.notImportedDiscoveries} type={'field_results'} /> : null),

      new Tab('Imported Prospects (' + importedProspectsCount.toString() + ')', hasImportedProspects ? <SpatialGridComponent messageBoxGlobal={messageBoxGlobal} data={data.importedProspects} type={'field_results'} /> : null),
      new Tab('Not Imported Prospects (' + notImportedProspectsCount.toString() + ')', hasNotImportedProspects ? <SpatialGridComponent messageBoxGlobal={messageBoxGlobal} data={data.notImportedProspects} type={'field_results'} /> : null),

      new Tab('Imported Segments (' + importedSegmentsCount.toString() + ')', hasImportedSegments ? <SpatialGridComponent messageBoxGlobal={messageBoxGlobal} data={data.importedSegments} type={'segments'} /> : null),
    ];

  }

  return (
    <div className="spatial-import-results">
      <h1>Spatial Import Results</h1>
      <TabPanelComponent toolbarItems={tabs} selectedItemIndex={0} />
    </div>
  );
};


export default SpatialImportResults;